import routes from '@/modules/job/job-routes';
import store from '@/modules/job/job-store';
// import JobAutocompleteInput from '@/modules/job/components/job-autocomplete-input';

export default {
  // components: [JobAutocompleteInput],
  routes,
  store,
};
